// extracted by mini-css-extract-plugin
export default {"moveIcon":"AdminMobileMainPage_moveIcon__t2Xw2","borderBot":"AdminMobileMainPage_borderBot__GgD-H"};